var generateStyle = function generateStyle(componentTheme) {
  return {
    question: {
      width: '100%',
      color: componentTheme.questionColor,
      backgroundColor: componentTheme.questionBackgroundColor,
      boxSizing: 'border-box',
      '& fieldset': {
        border: 'none'
      }
    },
    stem: {
      flex: '11 11 auto',
      marginBottom: componentTheme.stemMargin
    }
  };
};
export default generateStyle;